"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataType = void 0;
var DataType;
(function (DataType) {
    DataType[DataType["Text"] = 1] = "Text";
    DataType[DataType["Number"] = 2] = "Number";
    DataType[DataType["Integer"] = 6] = "Integer";
    DataType[DataType["Single"] = 10] = "Single";
    DataType[DataType["Double"] = 18] = "Double";
    DataType[DataType["Decimal"] = 34] = "Decimal";
    DataType[DataType["DateTime"] = 256] = "DateTime";
    DataType[DataType["Time"] = 768] = "Time";
    DataType[DataType["Date"] = 1280] = "Date";
    DataType[DataType["Boolean"] = 2048] = "Boolean";
    DataType[DataType["UId"] = 4096] = "UId";
    DataType[DataType["Undetermined"] = 65536] = "Undetermined";
})(DataType = exports.DataType || (exports.DataType = {}));
//# sourceMappingURL=DataType.js.map